<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <h1>Vonalkód jóváhagyás</h1>

          <div v-if="requests.length > 0" class="table-with-title">
            <table class="list">
              <tr>
                <th>Név</th>
                <th>Email</th>
                <th>Igénylés dátuma</th>
                <th>Csoport</th>
                <th>Mennyiség</th>
                <th style="width: 15%;">Engedély</th>
                <th>Megjegyzés</th>
                <th style="text-align: center;">Jóváhagyva</th>
                <th>Jóváhagyás dátuma</th>
                <th></th>
              </tr>

              <tr v-for="request in requests">
                <td>{{ request.name }}</td>
                <td>{{ request.email }}</td>
                <td>{{ request.request_date }}</td>
                <td>{{ request.groupname }}</td>
                <td style="text-align: center;">
                  <inputbox style="width: 70px" :disabled="request.approved == 1" :errors="errors" regexp_filter="[0-9]+" label="" :key="'amount_'+request.id" :id="'amount_'+request.id" v-model="request.amount" />
                </td>
                <td>
                  <checkbox :disabled="request.approved == 1" v-for="al in request.access_levels" :label="al.name" :id="'alc_'+request.id+'_'+al.access_level_id" v-model="al.selected"/>
                </td>
                <td>{{ request.comment }}</td>
                <td style="text-align: center;">
                  <i v-if="request.approved == 0" class="fa fa-minus"></i>
                  <i v-if="request.approved == 1" class="fa fa-check"></i>
                </td>
                <td>{{ request.approved_date }}</td>
                <td class="buttons">
                  <button v-if="request.approved == 0" @click="approve(request.id)" class="small-button" title="Igénylés jóváhagyása"><i class="fa fa-check"></i></button>
                  <button v-if="request.approved == 0" @click="del(request.id)" class="small-button" title="Igénylés törlése"><i class="fa fa-trash-alt"></i></button>
                </td>
              </tr>
            </table>
          </div>
          <div v-else>
            Nem található vonalkód igénylés.
          </div>
        </div>
      </div>

      <HTMLFooter></HTMLFooter>
      <ProgressInfo :show="is_save"/>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
    return {
      requests: [],
      errors: [],
      is_save: false
    };
  },
  mounted: function() {
    this.getRequests();
  },
  methods: {
    getRequests: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodeRequestsToApproved/' + _this.$root.user.apikey, {
          success: function(response) {
            _this.requests = response.requests;
          }
        });
      });
    },

    approve: function(id) {
      var _this = this;

      this.errors = [];

      var selected_request;

      this.requests.map(function(request) {
        if (request.id == id)
          selected_request = request;
      });

      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodeRequest/approve/' + _this.$root.user.apikey, {
          method: 'POST',
          data: selected_request,
          success: function(response) {
            _this.is_save = false;

            if (response.errors != undefined) {
              _this.errors = response.errors;
            } else {
              _this.getRequests();
            }
          }
        });
      });
    },

    del: function(id) {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('barcodeRequest/del/' + _this.$root.user.apikey + '/' + id, {
          success: function(response) {
            _this.getRequests();
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// barcode_approval.vue?2320c293